import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Nav, NavItem } from "react-bootstrap";
import { LinkContainer, IndexLinkContainer } from "react-router-bootstrap";
import {
  IoChevronBack,
  IoDocumentText,
  IoBriefcase,
  IoDocument,
  IoCard
} from "react-icons/io5";

import isEmpty from "lodash/isEmpty";

import MenuFooter from "./MenuFooter";

class ContractMenu extends Component {
  render() {
    const { contract, onClickMenu } = this.props;
    // let type = find(this.props.codes, { id: contract.contract_type });

    return (
      <Nav className="sidebar sidebar-nav">
        <IndexLinkContainer to="/app/contracts">
          <NavItem eventKey={1} onClick={onClickMenu}>
            <IoChevronBack size={16} />
            All Contracts
          </NavItem>
        </IndexLinkContainer>
        <LinkContainer exact to={`/app/contracts/${contract._id}`}>
          <NavItem eventKey={2} onClick={onClickMenu}>
            <IoDocumentText size={15} />
            <span>Contract Info</span>
          </NavItem>
        </LinkContainer>
        <LinkContainer to={`/app/contracts/${contract._id}/projects/0`}>
          <NavItem eventKey={2} onClick={onClickMenu}>
            <IoBriefcase size={15} />
            <span>Projects</span>
          </NavItem>
        </LinkContainer>
        {!isEmpty(contract) && contract.contract_type.label === "PREPAID" && (
          <LinkContainer to={`/app/contracts/${contract._id}/prepaids`}>
            <NavItem eventKey={2} onClick={onClickMenu}>
              <IoCard size={15} />
              <span>Prepaid Purchases</span>
            </NavItem>
          </LinkContainer>
        )}
        <LinkContainer to={`/app/contracts/${contract._id}/notes`}>
          <NavItem eventKey={2} onClick={onClickMenu}>
            <IoDocument size={15} />
            <span>Notes</span>
          </NavItem>
        </LinkContainer>
        <MenuFooter />
      </Nav>
    );
  }
}

ContractMenu.propTypes = {
  contract: PropTypes.object.isRequired,
  onClickMenu: PropTypes.func
};

function mapStatesToProps(state) {
  return {
    state,
    contract: state.reducers.contract
  };
}

export default connect(mapStatesToProps)(ContractMenu);
